import "./App.css";
// import { AiOutlineShopping, AiOutlineFileText } from "react-icons/ai"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Main from "./pages/main";
import AboutApp from "./pages/aboutApp";
import Templates from "./pages/templates";
import AddTemplate from "./pages/templatesPages/addTemplate";
import LoginCode from "./pages/loginCode";
import Sales from "./pages/sales";
import NewSales from "./pages/newSales";
import WebApp from "@twa-dev/sdk";
import { useEffect } from "react";
import Payment from "./pages/payment";

function App() {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;

    if (tg) {
      tg.setHeaderColor("#ffffff"); // Устанавливаем свой цвет шапки
      tg.setBackgroundColor("#ffffff");
      WebApp.ready();
      WebApp.expand();
    } else {
      window.location.href = "https://t.me/digitalkassir_bot";
    }
  }, []);
  return (
    <Router>
      <div className="wrapper">
        <Routes>
          <Route path="/payment/:id" element={<Payment />} />
          <Route path="/" element={<Login />} />
          <Route path="/login-code" element={<LoginCode />} />
          <Route path="/main" element={<Main />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/add-template" element={<AddTemplate />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/sales/new" element={<NewSales />} />
          <Route path="/about-app" element={<AboutApp />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
